import { Component, Vue, Watch } from 'vue-property-decorator';

import SelectDropdown from '@/components/SelectDropdown.vue';
import DateDropdown from '@/components/DateDropdown.vue';
import SelectAir from '@/components/SelectAir.vue';
import Workflow from '../Workflow';
import changeAirport from '../../../assets/js/airport/changeAirport';

import moment from 'moment';
import { Dialog } from 'vant';
import { TimeSelect } from 'element-ui';

Vue.use(TimeSelect);


// 注册组件路由守卫钩子
Component.registerHooks([
  'beforeRouteEnter',
]);

@Component({
  components: {
    SelectDropdown,
    DateDropdown,
    SelectAir,
  },
  filters: {
    Date(data: any) {
      return moment(data).format('YYYY-MM-DD');
    },
  },
})
export default class TripInfoNew extends Vue {
  private isStartShow: any = false; // 出发地弹出层控制
  private isEndShow: any = false; // 目的地弹出层控制
  private hasTripInfoDialog: boolean = false; // 已有行程信息弹出框
  private hasTripInfoList: any = []; // 已有行程信息列表
  private hasTripInfoConfirmFunction: any = null; // 已有行程信息弹出框 点击确认后执行的函数
  private $api: any;
  private startPlace: any = {         // 出发地
    airportCode: '',
  };
  private endPlace: any = {           // 目的地
    airportCode: '',
  };
  private airportTime: any = '';      // 出发时间
  private businessTrip: any = {       // 选择关联的出差
    id: '', value: '',
  };
  private isHourEdit: boolean = false; // 小时是否可编辑
  private businessTripId: any = '';
  private departStartTime: string = '00:00'; // 起始时间段
  private departEndTime: string = '24:00'; // 结束时间段
  private businessTripData: any = []; // 出差数据源
  private isEdit = false;             // 编辑状态
  private currentTripInfoId: string = ''; // 当前选择的行程id
  private currentTripInfoWorkFlowStatus: string = ''; // 当前选择的行程工作流状态 (用于判断是否需要重置工作流再提交)
  private isSubmitting: boolean = false;  // 是否正在提交
  private canSubmit: boolean = false;     // 是否可以提交
  private formStatus: any = {             // 用于验证是否可以提交
    businessTrip: false,
    startPlace: false,
    endPlace: false,
    airportTime: false,
  };

  @Watch('businessTrip.id')
  private onBusinessTripChange(val: any) {
    this.formStatus.businessTrip = Boolean(val);
    this.checkSubmit();
  }
  @Watch('startPlace.airportCode')
  private onStartPlaceChange(val: any) {
    this.formStatus.startPlace = Boolean(val);
    this.checkSubmit();
  }
  @Watch('endPlace.airportCode')
  private onEndPlaceChange(val: any) {
    this.formStatus.endPlace = Boolean(val);
    this.checkSubmit();
  }
  @Watch('airportTime')
  private onAirportTimeChange(val: any) {
    this.formStatus.airportTime = Boolean(val);
    this.checkSubmit();
    this.setDefaultHours();
  }
  private checkSubmit() {
    let canSubmit = true;
    for (const k of Object.keys(this.formStatus)) {
      if (!this.formStatus[k]) {
        canSubmit = false;
      }
    }
    this.canSubmit = canSubmit;
  }

  // 默认小时数赋值
  private setDefaultHours() {

    if (!this.airportTime || !this.businessTrip.id) {
      return;
    }

    const businessTrip = this.businessTripData.find((b: any) => {
      return b.Id === this.businessTrip.id;
    });

    if (businessTrip.BeginAt && moment(businessTrip.BeginAt).format('YYYY-MM-DD') === moment(this.airportTime).format('YYYY-MM-DD')) {
      this.departStartTime = moment(businessTrip.BeginAt).format('HH:mm');
    }

    if (businessTrip.EndAt && moment(businessTrip.EndAt).format('YYYY-MM-DD') === moment(this.airportTime).format('YYYY-MM-DD')) {
      this.departEndTime = moment(businessTrip.EndAt).format('HH:mm');
    }
  }

  // 创建时
  private created() {
    // if (location.hash === '#/tripinfo-edit') {
    //   this.isEdit = true;
    // }
    // if (!this.isEdit) {
    //   return;
    // }
    // const editTripInfo = JSON.parse(localStorage.getItem('EditTripInfo') || '');
    // if (!editTripInfo) {
    //   this.$toast('获取信息失败');
    //   return;
    // }
    // this.businessTrip = {
    //   id: editTripInfo.BusinessTripInfoId, value: editTripInfo.BusinessTripInfoText,
    // };
    // this.startPlace = {
    //   airportCode: editTripInfo.StartAirport, cityCName: changeAirport.changeAirportCode(editTripInfo.StartAirport).cityCName,
    // };
    // this.endPlace = {
    //   airportCode: editTripInfo.EndAirport, cityCName: changeAirport.changeAirportCode(editTripInfo.EndAirport).cityCName,
    // };
    // this.airportTime = editTripInfo.StartTime;
    // this.currentTripInfoId = editTripInfo.TripTrafficId;
    // this.currentTripInfoWorkFlowStatus = editTripInfo.TripWorkflowStatus;
    this.getBussinessTripTrafficInfo();
    if (this.$route.query.BusinessTripInfoId) {
      const id = this.$route.query.BusinessTripInfoId ? this.$route.query.BusinessTripInfoId : JSON.parse(localStorage.getItem('THIS_LOCATION_HREF_QUERY') || '').BusinessTripInfoId;
      this.businessTripId = id;
      // this.getBusinessTripInfo(id);

    } else {
      const tripInfo = JSON.parse(localStorage.getItem('CurrentTripInfo') || '{}');
      if (tripInfo) {
        this.startPlace = {
          airportCode: tripInfo.StartAirport, cityCName: changeAirport.changeAirportCode(tripInfo.StartAirport).cityCName,
        };
        this.endPlace = {
          airportCode: tripInfo.EndAirport, cityCName: changeAirport.changeAirportCode(tripInfo.EndAirport).cityCName,
        };
        this.businessTripId = tripInfo.BusinessTripInfoId;
        this.airportTime = tripInfo.StartTime;
        this.currentTripInfoId = tripInfo.TripTrafficId;
        this.currentTripInfoWorkFlowStatus = tripInfo.TripWorkflowStatus;
      }
    }
  }

  // 获取出差数据源
  private async getBussinessTripTrafficInfo() {
    const result = await this.$api.httpGet('Membership/TripInfo/GetBussinessTravelInformation');
    if (result.Success) {
      this.businessTripData = result.Data;
      for (const businesstrip of this.businessTripData) {
        businesstrip.id = businesstrip.Id;
        businesstrip.text = moment(businesstrip.BeginAt).format('YYYY-MM-DD HH:mm') + ' ~ ' + moment(businesstrip.EndAt).format('YYYY-MM-DD HH:mm');
      }
      if (this.businessTripId) {
        const businessTrip = this.businessTripData.find((b: any) => {
          return b.Id === this.businessTripId;
        });
        if (businessTrip) {
          this.businessTrip.id = businessTrip.Id;
          this.businessTrip.value = businessTrip.text;
          this.businessTrip.BeginAt = businessTrip.BeginAt;
          this.businessTrip.EndAt = businessTrip.EndAt;
        }
      }
    }
  }

  // 查询出差信息
  private async getBusinessTripInfo(id: string) {
    const model = {
      BusinessTripInfoId: id,
    };
    const result = await this.$api.httpGet('Membership/TripInfo/GetBusinessTripInfoById', model);
    if (result.Success) {
      if (result.Data) {
        // ...
      }
    }
  }

  // 返回上一级
  private back() {
    this.$router.go(-1);
  }


  // 确定
  private sure() {

    const params = {
      BusinessTripInfoId: this.businessTrip.id,
      StartAirport: this.startPlace.airportCode,
      EndAirport: this.endPlace.airportCode,
      StartTime: this.airportTime ? moment(this.airportTime).format('YYYY-MM-DD') : '',
      departStartTime: this.departStartTime,
      departEndTime: this.departEndTime,
      BeginAt: '',
      EndAt: '',
    };

    const businessTrip = this.businessTripData.find((b: any) => {
      return b.Id === this.businessTrip.id;
    });

    if (businessTrip) {
      params.BeginAt = businessTrip.BeginAt;
      params.EndAt = businessTrip.EndAt;
    }

    if (params.BeginAt && params.EndAt) {
      if (moment(params.StartTime + ' ' + params.departStartTime).toDate() < moment(params.BeginAt).toDate() || moment(params.StartTime + ' ' + params.departEndTime).toDate() > moment(params.EndAt).toDate()) {
        this.$toast('您选择的航班时间不在您的出差时间范围内 ' + moment(params.BeginAt).format('YYYY-MM-DD HH:mm') + '-' + moment(params.EndAt).format('YYYY-MM-DD HH:mm') + '，请重新选择，或更改您的出差申请时间后再预订机票。');
        return;
      }
    }

    localStorage.setItem('AirTicketFor', 'booking');
    localStorage.setItem('AirTicketTrip', JSON.stringify(params));
    localStorage.setItem('CurrentTripInfo', JSON.stringify(params));
    this.$router.push('/airticket-booking');
  }


  // 检查当天有没有其他行程
  // next: 是一个函数，可能为 this.save 或者 this.edit, 用next()来执行新建或者编辑
  private async confirmTrips(next: any) {
    if (this.isSubmitting || !this.canSubmit) {
      return;
    }
    const params = {
      Id: this.currentTripInfoId,
      BusinessTripInfoId: this.businessTrip.id,
      StartTime: this.airportTime ? moment(this.airportTime).format('YYYY-MM-DD') : '',
    };
    if (!params.BusinessTripInfoId) {
      this.$toast('请将表单填写完整');
      return;
    }
    this.isSubmitting = true;
    const result = await this.$api.httpPost('Membership/TripInfo/PostJudgeTripHave', params);
    if (result.Success) {
      // console.log(result.Data);
      if (result.Data && result.Data.length > 0) {
        this.hasTripInfoConfirmFunction = next; // 函数存入属性中，等待按钮点击调用
        this.hasTripInfoList = result.Data;
        this.hasTripInfoDialog = true;
      } else {
        next();
      }
    }
  }
  // 点击取消
  private confirmTripsCancel() {
    this.isSubmitting = false;
  }

  // 新建行程 - 提交
  private async save() {
    const params = {
      Id: this.businessTrip.id,
      StartAirport: this.startPlace.airportCode,
      EndAirport: this.endPlace.airportCode,
      StartTime: this.airportTime ? moment(this.airportTime).format('YYYY-MM-DD') : '',
    };
    // console.log(params);
    if (!this.check(params)) {
      this.$toast('请将表单填写完整');
      this.isSubmitting = false;
      return;
    }
    this.$toast.loading({
      duration: 0,       // 持续展示toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在提交...',
    });
    const result = await this.$api.httpPost('Membership/TripBookTicket/PostStorageTripInfoWeChat', params);
    if (result.Success && result.Data) {
      const TargetEntityId = result.Data.TargetEntityId;
      // 提交工作流
      Workflow.Submit('0033', TargetEntityId, (response: any) => {
        if (response.Data) {
          this.$toast.clear();
          // 延时三秒发送企业微信通知
          setTimeout(() => {
            this.SendMessageSubmit(TargetEntityId);
          }, 3000);
          Dialog.alert({
            message: '提交成功',
            confirmButtonText: '确定',
          }).then(() => {
            // on close
            this.isSubmitting = false;
            this.$router.go(-1);
          });
        } else {
          this.$toast.clear();
          this.$toast(`工作流开启失败:${response.AllMessages}`);
          this.isSubmitting = false;
        }
      }, (error: any) => {
        this.$toast.clear();
        this.$toast(`工作流开启失败:${error}`);
        this.isSubmitting = false;
      });
    } else {
      this.$toast.clear();
      this.$toast(`提交失败:${result.AllMessages}`);
      this.isSubmitting = false;
    }

  }

  // 编辑行程 - 提交
  private async edit() {
    const params = {
      TripTrafficId: this.currentTripInfoId,
      BusinessTripInfoId: this.businessTrip.id,
      StartAirport: this.startPlace.airportCode,
      EndAirport: this.endPlace.airportCode,
      StartTime: this.airportTime ? moment(this.airportTime).format('YYYY-MM-DD') : '',
    };
    // console.log(params);
    if (!this.check(params)) {
      this.$toast('请将表单填写完整');
      this.isSubmitting = false;
      return;
    }
    this.$toast.loading({
      duration: 0,       // 持续展示toast
      forbidClick: true, // 禁用背景点击
      loadingType: 'spinner',
      message: '正在提交...',
    });
    const result = await this.$api.httpPost('Membership/TripBookTicket/PostSaveTripInfo', params);
    if (result.Success && result.Data) {
      const TargetEntityId = result.Data.TargetEntityId;
      if (this.currentTripInfoWorkFlowStatus === 'DRAFT') {
        // 重置再提
        Workflow.Reset(TargetEntityId, (resetResponse: any) => {
          if (resetResponse.Success) {
            // 提交工作流
            Workflow.Submit('0033', TargetEntityId, (response: any) => {
              if (response.Success && response.Data) {
                this.$toast.clear();
                this.isSubmitting = false;
                // 延时三秒发送企业微信通知
                setTimeout(() => {
                  this.SendMessageSubmit(TargetEntityId);
                }, 3000);
                Dialog.alert({
                  message: '提交成功',
                  confirmButtonText: '确定',
                }).then(() => {
                  // on close
                  this.$router.go(-1);
                  this.isSubmitting = false;
                });
              } else {
                this.$toast.clear();
                this.$toast(`工作流开启失败:${response.AllMessages}`);
                this.isSubmitting = false;
              }
            }, (error: any) => {
              this.$toast.clear();
              this.$toast(`工作流开启失败:${error}`);
              this.isSubmitting = false;
            });
          } else {
            this.$toast.clear();
            this.$toast(`提交失败:${resetResponse.AllMessages}`);
            this.isSubmitting = false;
          }
        }, (error: any) => {
          this.$toast(`工作流重置失败:${error}`);
          this.isSubmitting = false;
        });
      }
      // 提交工作流
      Workflow.Submit('0033', TargetEntityId, (response: any) => {
        if (response.Success && response.Data) {
          this.$toast.clear();
          this.isSubmitting = false;
          // 延时三秒发送企业微信通知
          setTimeout(() => {
            this.SendMessageSubmit(TargetEntityId);
          }, 3000);
          Dialog.alert({
            message: '提交成功',
            confirmButtonText: '确定',
          }).then(() => {
            // on close
            this.$router.go(-1);
          });
        } else {
          this.$toast.clear();
          this.$toast(`工作流开启失败:${response.AllMessages}`);
          this.isSubmitting = false;
        }
      }, (error: any) => {
        this.$toast.clear();
        this.$toast(`工作流开启失败:${error}`);
        this.isSubmitting = false;
      });
    } else {
      this.$toast.clear();
      this.$toast(`提交失败:${result.AllMessages}`);
      this.isSubmitting = false;
    }

  }

  private check(params: any) {
    for (const k of Object.keys(params)) {
      if (!params[k]) {
        this.$toast('请将信息填写完整');
        return false;
      }
    }
    return true;
  }


  // 发送企业微信通知
  private async SendMessageSubmit(TripTrafficId: string) {
    const result = await this.$api.httpGet('Membership/TripInfo/GetSendMessageSubmit', { TripTrafficId });
    if (!result.Success) {
      if (result.AllMessages !== 'draft') {
        this.$toast(`行程信息: ${result.AllMessages}`);
      }
    }
  }



  // 关闭出发地弹窗
  private closeStartPop(val: any) {
    this.isStartShow = false;
    if (val) {
      this.startPlace = val;
    }
  }
  // 关闭出发地弹窗
  private closeEndPop(val: any) {
    this.isEndShow = false;
    if (val) {
      this.endPlace = val;
    }
  }
}
